module.exports = __webpack_public_path__ + "static/media/Screenshot 4.cd68bd88.JPG";